import React from "react";
import NavBar from "../components/layout/NavBar";
import Footer from "../components/layout/Footer";

import bgHero from "../images/bg-hero.png";
import svgArrowBtn from "../images/arrow-btn.svg";
import Logobgtransparentblack from "../images/DA_NoxZi/Logo-bg-transparent-black.png";

export default function ContactPage() {
  return (
    <div className="relative min-h-screen overflow-hidden bg-white text-black selection:bg-black selection:text-white">
      {/* <div className="absolute inset-0 z-0 h-[100vh]">
        <img
          src={bgHero}
          alt="Background"
          className="w-full h-full object-cover pt-20"
        />
      </div> */}

      <NavBar />

      {/* HERO */}
      <section className="relative z-10 px-6 pt-20 pb-24 md:pt-24 md:pb-32 text-center">
        <div className="mb-6 flex items-center justify-center">
          <div className="rounded-full border border-black/10 bg-white/70 px-4 py-2 backdrop-blur-md shadow-[0_6px_20px_rgba(0,0,0,0.05)]">
            <p className="font-asap text-[12px] uppercase tracking-[0.28em] text-[#b98c42]">
              Contact
            </p>
          </div>
        </div>

        <h1 className="text-[2.2rem] md:text-[5.6rem] leading-[0.92] tracking-[-0.08em] font-[600] font-asap text-black max-w-6xl mx-auto">
          Parlons de votre
          <br className="hidden md:block" />
          prochain projet digital
        </h1>

        <p className="mt-7 text-[17px] md:text-[21px] text-black/60 max-w-3xl mx-auto font-asap leading-relaxed">
          Application mobile, site web, interface d'administration ou besoin plus
          spécifique : échangeons sur votre projet, vos objectifs et la meilleure
          manière de le concrétiser.
        </p>

        <div className="mt-8 flex items-center justify-center gap-4 flex-wrap">
          <a
            href="https://cal.com/noxzi/30min"
            className="font-asap bg-black text-white px-6 py-3 rounded-full shadow-[0_9px_10px_rgba(0,0,0,0.25),_inset_0_2px_7.3px_#ffffff] hover:scale-[1.05] transition-transform inline-flex items-center gap-2"
          >
            Réserver un appel
            <img src={svgArrowBtn} alt="Arrow" className="w-4 h-4 invert" />
          </a>

          <a
            href="mailto:contact@noxzi.com"
            className="font-asap border border-black/20 text-black px-6 py-3 rounded-full hover:bg-black hover:text-white transition-all inline-flex items-center"
          >
            contact@noxzi.com
          </a>
        </div>

        <div className="mt-16 flex justify-center">
          <div className="relative w-full max-w-5xl overflow-hidden rounded-[36px] border border-white/40 bg-white/60 backdrop-blur-xl shadow-[0_24px_80px_rgba(0,0,0,0.08)] p-8 md:p-12">
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(201,163,95,0.10),transparent_30%)]" />
            <div className="relative z-10 grid md:grid-cols-3 gap-6 text-left">
              <div>
                <p className="font-asap text-[11px] uppercase tracking-[0.24em] text-[#b98c42] mb-3">
                  Échange
                </p>
                <p className="font-asap text-black/75 leading-relaxed">
                  Un premier contact simple pour comprendre votre besoin et votre contexte.
                </p>
              </div>
              <div>
                <p className="font-asap text-[11px] uppercase tracking-[0.24em] text-[#b98c42] mb-3">
                  Conseil
                </p>
                <p className="font-asap text-black/75 leading-relaxed">
                  Nous vous orientons vers la solution la plus pertinente selon vos objectifs.
                </p>
              </div>
              <div>
                <p className="font-asap text-[11px] uppercase tracking-[0.24em] text-[#b98c42] mb-3">
                  Suite
                </p>
                <p className="font-asap text-black/75 leading-relaxed">
                  Si le projet est aligné, nous pouvons ensuite structurer une proposition claire.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="absolute top-[70vh] left-0 w-full h-96 bg-[linear-gradient(180deg,rgba(255,255,255,0)_4.41%,#fff_76.1%)] mix-blend-lighten z-20 pointer-events-none" />

      {/* CONTACT CONTENT */}
      <section className="relative px-6 py-24 overflow-hidden">
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute inset-0 opacity-[0.03] [background-image:radial-gradient(#000_0.7px,transparent_0.7px)] [background-size:18px_18px]" />
          <div className="absolute top-12 left-[8%] w-72 h-72 rounded-full bg-[#c9a35f]/[0.06] blur-3xl" />
          <div className="absolute bottom-10 right-[8%] w-80 h-80 rounded-full bg-black/[0.03] blur-3xl" />
        </div>

        <div className="max-w-6xl mt-60 mx-auto relative z-10 grid lg:grid-cols-[1.15fr_0.85fr] gap-8 items-start">
          {/* FORM */}
          <div className="relative overflow-hidden rounded-[34px] border border-black/[0.06] bg-[linear-gradient(180deg,#ffffff_0%,#f7f7f7_100%)] p-8 md:p-10 shadow-[0_12px_30px_rgba(0,0,0,0.035)]">
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(201,163,95,0.10),transparent_34%)]" />
            <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#c9a35f]/25 to-transparent" />

            <div className="relative z-10">
              <div className="flex items-start justify-between mb-10">
                <div>
                  <p className="font-asap uppercase tracking-[0.34em] text-[11px] text-[#b98c42] mb-4">
                    Formulaire
                  </p>
                  <h2 className="text-[2rem] md:text-[3rem] leading-[0.96] tracking-[-0.06em] font-[600] font-asap text-black">
                    Présentez-nous votre besoin
                  </h2>
                </div>

                <div className="w-12 h-12 rounded-full border border-black/[0.08] bg-[#f8f8f8] flex items-center justify-center shrink-0">
                  <img
                    src={Logobgtransparentblack}
                    alt="NoxZi"
                    className="w-5 h-5 object-contain opacity-80"
                  />
                </div>
              </div>

              <form
                action="mailto:contact@noxzi.com"
                method="post"
                encType="text/plain"
                className="space-y-5"
              >
                <div className="grid md:grid-cols-2 gap-5">
                  <div>
                    <label className="block font-asap text-[12px] uppercase tracking-[0.18em] text-black/45 mb-3">
                      Nom
                    </label>
                    <input
                      type="text"
                      name="nom"
                      placeholder="Votre nom"
                      className="w-full rounded-[18px] border border-black/10 bg-white px-5 py-4 font-asap text-black outline-none transition-all focus:border-[#b98c42]/50 focus:shadow-[0_0_0_4px_rgba(185,140,66,0.08)]"
                    />
                  </div>

                  <div>
                    <label className="block font-asap text-[12px] uppercase tracking-[0.18em] text-black/45 mb-3">
                      Email
                    </label>
                    <input
                      type="email"
                      name="email"
                      placeholder="Votre email"
                      className="w-full rounded-[18px] border border-black/10 bg-white px-5 py-4 font-asap text-black outline-none transition-all focus:border-[#b98c42]/50 focus:shadow-[0_0_0_4px_rgba(185,140,66,0.08)]"
                    />
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-5">
                  <div>
                    <label className="block font-asap text-[12px] uppercase tracking-[0.18em] text-black/45 mb-3">
                      Structure
                    </label>
                    <input
                      type="text"
                      name="structure"
                      placeholder="Entreprise, association, projet..."
                      className="w-full rounded-[18px] border border-black/10 bg-white px-5 py-4 font-asap text-black outline-none transition-all focus:border-[#b98c42]/50 focus:shadow-[0_0_0_4px_rgba(185,140,66,0.08)]"
                    />
                  </div>

                  <div>
                    <label className="block font-asap text-[12px] uppercase tracking-[0.18em] text-black/45 mb-3">
                      Type de besoin
                    </label>
                    <select
                      name="besoin"
                      className="w-full rounded-[18px] border border-black/10 bg-white px-5 py-4 font-asap text-black outline-none transition-all focus:border-[#b98c42]/50 focus:shadow-[0_0_0_4px_rgba(185,140,66,0.08)]"
                    >
                      <option>Application mobile</option>
                      <option>Site web</option>
                      <option>UI / UX Design</option>
                      <option>Back-office / dashboard</option>
                      <option>Accompagnement produit</option>
                      <option>Autre</option>
                    </select>
                  </div>
                </div>

                <div>
                  <label className="block font-asap text-[12px] uppercase tracking-[0.18em] text-black/45 mb-3">
                    Message
                  </label>
                  <textarea
                    name="message"
                    rows="7"
                    placeholder="Décrivez votre projet, vos besoins, votre contexte et ce que vous recherchez."
                    className="w-full rounded-[22px] border border-black/10 bg-white px-5 py-4 font-asap text-black outline-none resize-none transition-all focus:border-[#b98c42]/50 focus:shadow-[0_0_0_4px_rgba(185,140,66,0.08)]"
                  />
                </div>

                <div className="pt-3 flex flex-col sm:flex-row gap-4">
                  <button
                    type="submit"
                    className="inline-flex items-center justify-center gap-3 rounded-full bg-black text-white px-7 py-3.5 font-asap font-medium transition-all duration-300 hover:scale-[1.04] shadow-[0_9px_10px_rgba(0,0,0,0.25),_inset_0_2px_7.3px_#ffffff]"
                  >
                    Envoyer la demande
                    <img src={svgArrowBtn} alt="Arrow" className="w-4 h-4 invert" />
                  </button>

                  <a
                    href="https://cal.com/noxzi/30min"
                    className="inline-flex items-center justify-center rounded-full border border-black/15 px-7 py-3.5 font-asap font-medium text-black transition-all duration-300 hover:bg-black hover:text-white"
                  >
                    Réserver un appel à la place
                  </a>
                </div>
              </form>
            </div>
          </div>

          {/* SIDE CARDS */}
          <div className="space-y-6">
            <div className="relative overflow-hidden rounded-[34px] border border-white/10 bg-black px-8 py-9 shadow-[0_30px_90px_rgba(0,0,0,0.18)]">
              <div className="absolute inset-0 opacity-[0.08]">
                <img src={bgHero} alt="" className="w-full h-full object-cover" />
              </div>
              <div className="absolute inset-0 opacity-[0.035] [background-image:radial-gradient(#fff_0.7px,transparent_0.7px)] [background-size:18px_18px]" />
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(201,163,95,0.22),transparent_28%)]" />

              <div className="relative z-10">
                <p className="font-asap uppercase tracking-[0.28em] text-[10px] text-[#d1a75f] mb-4">
                  Échange rapide
                </p>
                <h3 className="text-[2rem] leading-[0.98] tracking-[-0.06em] font-asap font-[500] text-white mb-5">
                  Réservez un créneau
                </h3>
                <p className="text-white/70 font-asap leading-relaxed text-[16px] mb-8">
                  Pour échanger directement sur votre projet, le plus simple reste de
                  réserver un appel. Cela permet d'aller plus vite et de cadrer le besoin clairement.
                </p>

                <a
                  href="https://cal.com/noxzi/30min"
                  className="inline-flex items-center gap-3 rounded-full bg-white text-black px-6 py-3.5 font-asap font-medium transition-all duration-300 hover:scale-[1.04]"
                >
                  Réserver un appel
                  <img src={svgArrowBtn} alt="Arrow" className="w-4 h-4" />
                </a>
              </div>
            </div>

            <div className="rounded-[34px] border border-black/[0.06] bg-white p-8 shadow-[0_12px_30px_rgba(0,0,0,0.035)]">
              <p className="font-asap uppercase tracking-[0.34em] text-[11px] text-[#b98c42] mb-5">
                Informations
              </p>

              <div className="space-y-5">
                <div>
                  <p className="font-asap text-[12px] uppercase tracking-[0.18em] text-black/45 mb-2">
                    Email
                  </p>
                  <a
                    href="mailto:contact@noxzi.com"
                    className="font-asap text-[18px] text-black hover:text-[#9a7130] transition-colors"
                  >
                    contact@noxzi.com
                  </a>
                </div>

                <div>
                  <p className="font-asap text-[12px] uppercase tracking-[0.18em] text-black/45 mb-2">
                    Prise de rendez-vous
                  </p>
                  <a
                    href="https://cal.com/noxzi/30min"
                    className="font-asap text-[18px] text-black hover:text-[#9a7130] transition-colors"
                  >
                    cal.com/noxzi/30min
                  </a>
                </div>

                <div>
                  <p className="font-asap text-[12px] uppercase tracking-[0.18em] text-black/45 mb-2">
                    Type de projets
                  </p>
                  <p className="font-asap text-black/70 leading-relaxed">
                    Applications mobiles, sites web, design d'interface, back-office,
                    accompagnement produit et solutions digitales sur mesure.
                  </p>
                </div>
              </div>
            </div>

            <div className="rounded-[34px] border border-black/[0.06] bg-[linear-gradient(180deg,#ffffff_0%,#f7f7f7_100%)] p-8 shadow-[0_12px_30px_rgba(0,0,0,0.035)]">
              <p className="font-asap uppercase tracking-[0.34em] text-[11px] text-[#b98c42] mb-5">
                Ce que vous pouvez envoyer
              </p>

              <div className="space-y-4">
                {[
                  "Une présentation rapide de votre projet",
                  "Votre besoin principal",
                  "Votre échéance éventuelle",
                  "Vos questions ou vos hésitations",
                ].map((item, index) => (
                  <div key={item} className="flex items-start gap-4">
                    <div className="w-9 h-9 rounded-full border border-black/[0.08] bg-[#f8f8f8] flex items-center justify-center text-[12px] tracking-[0.14em] font-asap font-[600] text-[#b98c42] shrink-0">
                      0{index + 1}
                    </div>
                    <p className="font-asap text-black/80 leading-relaxed">{item}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ LIGHT */}
      <section className="relative px-6 pb-32 overflow-hidden">
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[70%] h-px bg-gradient-to-r from-transparent via-[#c9a35f]/20 to-transparent" />
          <div className="absolute inset-0 opacity-[0.03] [background-image:radial-gradient(#000_0.7px,transparent_0.7px)] [background-size:18px_18px]" />
        </div>

        <div className="max-w-5xl mx-auto relative z-10">
          <div className="text-center mb-14">
            <p className="font-asap uppercase tracking-[0.34em] text-[11px] text-[#b98c42] mb-5">
              Avant de nous écrire
            </p>
            <h2 className="text-[2.5rem] md:text-[4.8rem] leading-[0.95] tracking-[-0.075em] font-[600] font-asap text-black">
              Quelques précisions utiles
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            {[
              {
                title: "Projet en cours d'idée",
                text: "Même si tout n'est pas encore clair, nous pouvons vous aider à structurer le besoin et poser une base solide.",
              },
              {
                title: "Budget ou cadre à définir",
                text: "Le premier échange permet justement de comprendre le périmètre et d'identifier la bonne approche.",
              },
              {
                title: "Besoin spécifique",
                text: "Si votre demande sort du cadre classique, vous pouvez quand même nous écrire avec un maximum de contexte.",
              },
            ].map((item) => (
              <div
                key={item.title}
                className="rounded-[30px] border border-black/[0.06] bg-white p-7 shadow-[0_10px_28px_rgba(0,0,0,0.035)]"
              >
                <h3 className="text-[26px] leading-[1.02] tracking-[-0.05em] font-asap font-[500] text-black mb-4">
                  {item.title}
                </h3>
                <p className="text-black/60 font-asap leading-relaxed text-[15.5px]">
                  {item.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}